import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  changed: {
    marginBottom: theme.footerHeight + 50
  },
  // Condensed drawer: when the change starts, after the sections (prototype order).
  drawerStart: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    paddingTop: theme.spacing(4),
    borderTop: `1px solid ${theme.colorPalette.beige_60}`
  },
  hidden: {
    display: 'none'
  }
});

export default makeStyles(styles);
